export const languageOptions = [
  { code: "en", label: "English", shortLabel: "EN", dir: "ltr" },
  { code: "ar", label: "العربية", shortLabel: "AR", dir: "rtl" },
  { code: "ur", label: "اردو", shortLabel: "UR", dir: "rtl" }
];

export const translations = {
  en: {
    nav: {
      topLine: "Connecting Pakistan's Talent with Saudi Arabia & the Middle East Since 1998",
      home: "Home",
      about: "About Us",
      services: "Industries",
      gallery: "Gallery",
      contact: "Contact Us",
      requestManpower: "Request Manpower",
      openMenu: "Open navigation menu",
      closeMenu: "Close navigation menu",
      language: "Language"
    },
    hero: {
      kicker: "25+ Years of Trust & Excellence",
      title: ["Connecting Pakistan's", "Talent with", "Saudi Arabia", "& The Middle East"],
      description: "We provide reliable, efficient and professional manpower recruitment solutions to leading companies across Saudi Arabia and the Middle East.",
      primaryCta: "Hire Skilled Workers",
      secondaryCta: "Contact Us"
    },
    compact: {
      stats: ["Years of Experience", "Candidates Placed", "Satisfied Clients", "Countries Served"],
      whyTitle: ["Why Choose", "Pak Arabian", "Manpower Services?"],
      whyCards: [
        ["Licensed & Government Registered", "Approved by Ministry of Interior & MOFA, Government of Pakistan."],
        ["25+ Years of Excellence", "Over two decades of experience in international recruitment services."],
        ["Wide Pool of Skilled Workers", "Access to a large database of pre-screened and skilled candidates."],
        ["Fast & Reliable Visa Processing", "Efficient documentation and visa processing for quick deployment."],
        ["Trusted by Leading Companies", "Serving top organisations across Saudi Arabia and the Middle East."],
        ["Dedicated Support Team", "Our team is always ready to assist you with the best possible support."]
      ],
      aboutKicker: "About Pak Arabian",
      aboutTitle: ["A Professional Manpower Partner", "For Saudi Arabia & The Middle East"],
      aboutText: "We support international employers with practical recruitment coordination, candidate screening, documentation follow-up, and deployment readiness from Pakistan.",
      aboutPoints: ["Licensed manpower support", "Employer-focused coordination", "Reliable overseas deployment process"],
      downloadProfile: "Download Company Profile",
      viewProfile: "View Company Profile",
      trustedTitle: ["Trusted", "By Leading Companies"],
      trustedText: "Recognised by companies across multiple industries.",
      industriesTitle: ["Industries", "We Serve"],
      processTitle: ["Our Recruitment", "Process"],
      industries: [
        ["Construction", "Project manpower for site and civil works."],
        ["Engineering", "Technical workers for specialist roles."],
        ["Oil & Gas", "Industrial support for energy sectors."],
        ["Healthcare", "Healthcare and support staffing."],
        ["Manufacturing", "Factory, plant and production teams."],
        ["Hospitality", "Hotel, service and facilities staff."],
        ["Ceramic Industry", "Factory and production manpower support."],
        ["Transport", "Drivers, logistics and transport support roles."],
        ["Facility Management", "Maintenance and facilities workforce support."],
        ["And Many More", "Flexible manpower support for varied employer needs."]
      ],
      process: ["Requirement Received", "Candidate Screening", "Interviews & Trade Test", "Medical Examination", "Visa Processing", "Departure & Deployment"]
    },
    appreciations: {
      kicker: "Recognition",
      title: "Trusted by employers, recognized for service.",
      description: "",
      trustOne: "Verified Communication",
      trustTwo: "Documented Recognition",
      trustThree: "Employer focused Support",
      recognitionFrom: "Recognition from",
      recognitionText: "highlighting Pak Arabian's dependable recruitment and manpower support.",
      issuer: "Issuer",
      recognitionType: "Recognition Type",
      letter: "Letter",
      certificate: "Certificate",
      letterTitle: "Letter of Appreciation",
      certificateTitle: "Certificate of Appreciation",
      viewDocument: "View Full Document",
      hint: "Select a recognition to preview it in the showcase.",
      show: "Show",
      from: "from"
    },
    contact: {
      kicker: "Contact us",
      title: "Ready to discuss manpower requirements?",
      description: "Share your hiring needs, candidate questions, or company profile requests. Pak Arabian is ready to help you move forward with clarity.",
      whatsapp: "Message on WhatsApp",
      callNow: "Call Us Now",
      ourOffice: "Our Office",
      getInTouch: "Get in Touch",
      directionsText: "Get directions to our office",
      phone: "Phone",
      office: "Office",
      address: ["Pak Arabian Manpower Services", "2nd Floor, Midway Commercial", "Attar Plaza, Bahria Town Phase-VII", "Islamabad, Pakistan"],
      maps: "Open in Google Maps",
      hours: "Working Hours",
      days: "Monday to Saturday",
      time: "9:00 AM - 5:00 PM",
      email: "Email"
    },
    lower: {
      title: "Looking to hire skilled workers?",
      text: "We are here to provide the best manpower solutions for your business.",
      emailRequirements: "Email Requirements",
      call: "Call Us Now",
      whatsapp: "Chat on WhatsApp",
      copyright: "Pak Arabian Manpower Services.",
      designed: "Designed & Developed by Team LFM"
    }
  },
  ar: {
    nav: {
      topLine: "ربط المواهب الباكستانية بالسعودية والشرق الأوسط منذ عام 1998",
      home: "الرئيسية",
      about: "من نحن",
      services: "القطاعات",
      gallery: "الشهادات",
      contact: "اتصل بنا",
      requestManpower: "طلب عمالة",
      openMenu: "فتح قائمة التنقل",
      closeMenu: "إغلاق قائمة التنقل",
      language: "اللغة"
    },
    hero: {
      kicker: "أكثر من 25 عاماً من الثقة والتميز",
      title: ["نربط مواهب باكستان", "بالعمل في", "السعودية", "والشرق الأوسط"],
      description: "نقدم حلول توظيف عمالة موثوقة ومنظمة واحترافية للشركات الرائدة في السعودية والشرق الأوسط.",
      primaryCta: "توظيف عمالة ماهرة",
      secondaryCta: "اتصل بنا"
    },
    compact: {
      stats: ["سنوات الخبرة", "مرشح تم توظيفه", "عميل راض", "دول نخدمها"],
      whyTitle: ["لماذا تختار", "باك أرابيان", "لخدمات العمالة؟"],
      whyCards: [
        ["مرخصة ومسجلة حكومياً", "معتمدة من وزارة الداخلية ووزارة الخارجية في باكستان."],
        ["أكثر من 25 عاماً من التميز", "خبرة طويلة في خدمات التوظيف الدولي."],
        ["قاعدة واسعة من العمالة الماهرة", "وصول إلى قاعدة كبيرة من المرشحين المفروزين والمهرة."],
        ["إجراءات تأشيرات سريعة وموثوقة", "تنسيق مستندات وتأشيرات بكفاءة لسرعة الانتشار."],
        ["موثوقة من شركات رائدة", "نخدم مؤسسات في السعودية والشرق الأوسط."],
        ["فريق دعم متخصص", "فريقنا مستعد دائماً لمساعدتكم بأفضل دعم ممكن."]
      ],
      aboutKicker: "عن باك أرابيان",
      aboutTitle: ["شريك احترافي في العمالة", "للسعودية والشرق الأوسط"],
      aboutText: "ندعم أصحاب العمل الدوليين بتنسيق التوظيف وفرز المرشحين ومتابعة الوثائق والاستعداد للسفر من باكستان.",
      aboutPoints: ["دعم عمالة مرخص", "تنسيق يركز على صاحب العمل", "عملية سفر موثوقة"],
      downloadProfile: "تحميل ملف الشركة",
      viewProfile: "عرض ملف الشركة",
      trustedTitle: ["موثوقون", "من شركات رائدة"],
      trustedText: "معترف بنا من شركات في قطاعات متعددة.",
      industriesTitle: ["القطاعات", "التي نخدمها"],
      processTitle: ["عملية", "التوظيف"],
      industries: [
        ["البناء", "عمالة للمواقع والمشاريع المدنية."],
        ["الهندسة", "عمال فنيون للأدوار المتخصصة."],
        ["النفط والغاز", "دعم صناعي لقطاعات الطاقة."],
        ["الرعاية الصحية", "كوادر صحية ومساندة."],
        ["التصنيع", "فرق للمصانع والإنتاج."],
        ["الضيافة", "كوادر للفنادق والخدمات."],
        ["صناعة السيراميك", "عمالة للمصانع والإنتاج."],
        ["النقل", "سائقون ودعم لوجستي."],
        ["إدارة المرافق", "عمالة للصيانة والمرافق."],
        ["وغير ذلك", "دعم مرن لاحتياجات أصحاب العمل."]
      ],
      process: ["استلام المتطلبات", "فرز المرشحين", "المقابلات واختبار المهارة", "الفحص الطبي", "إجراءات التأشيرة", "السفر والانتشار"]
    },
    appreciations: {
      kicker: "التقدير",
      title: "ثقة أصحاب العمل وتقدير الخدمة.",
      description: "",
      trustOne: "تواصل موثوق",
      trustTwo: "تقدير موثق",
      trustThree: "دعم يركز على صاحب العمل",
      recognitionFrom: "تقدير من",
      recognitionText: "يعكس موثوقية باك أرابيان في التوظيف ودعم العمالة.",
      issuer: "الجهة المصدرة",
      recognitionType: "نوع التقدير",
      letter: "خطاب",
      certificate: "شهادة",
      letterTitle: "خطاب تقدير",
      certificateTitle: "شهادة تقدير",
      viewDocument: "عرض المستند الكامل",
      hint: "اختر تقديراً لمعاينته في العرض.",
      show: "عرض",
      from: "من"
    },
    contact: {
      kicker: "اتصل بنا",
      title: "هل ترغب في مناقشة احتياجات العمالة؟",
      description: "شاركنا احتياجات التوظيف أو أسئلة المرشحين أو طلبات ملف الشركة. باك أرابيان جاهزة لمساعدتك بوضوح.",
      whatsapp: "راسلنا على واتساب",
      callNow: "اتصل الآن",
      ourOffice: "مكتبنا",
      getInTouch: "تواصل معنا",
      directionsText: "احصل على الاتجاهات إلى مكتبنا",
      phone: "الهاتف",
      office: "المكتب",
      address: ["باك أرابيان لخدمات العمالة", "الطابق الثاني، ميدواي كومرشال", "عطار بلازا، بحريا تاون المرحلة السابعة", "إسلام آباد، باكستان"],
      maps: "فتح في خرائط Google",
      hours: "ساعات العمل",
      days: "من الاثنين إلى السبت",
      time: "9:00 صباحاً - 5:00 مساءً",
      email: "البريد الإلكتروني"
    },
    lower: {
      title: "هل تبحث عن توظيف عمالة ماهرة؟",
      text: "نقدم أفضل حلول العمالة لعملك.",
      emailRequirements: "إرسال المتطلبات بالبريد",
      call: "اتصل الآن",
      whatsapp: "الدردشة على واتساب",
      copyright: "باك أرابيان لخدمات العمالة.",
      designed: "تصميم فريق باك أرابيان"
    }
  },
  ur: {
    nav: {
      topLine: "پاکستانی ٹیلنٹ کو سعودی عرب اور مشرق وسطیٰ سے 1998 سے جوڑ رہے ہیں",
      home: "ہوم",
      about: "ہمارے بارے میں",
      services: "صنعتیں",
      gallery: "سرٹیفکیٹس",
      contact: "رابطہ کریں",
      requestManpower: "مین پاور طلب کریں",
      openMenu: "نیویگیشن مینو کھولیں",
      closeMenu: "نیویگیشن مینو بند کریں",
      language: "زبان"
    },
    hero: {
      kicker: "25+ سال اعتماد اور بہترین خدمات",
      title: ["پاکستانی ٹیلنٹ کو", "جوڑتے ہیں", "سعودی عرب", "اور مشرق وسطیٰ سے"],
      description: "ہم سعودی عرب اور مشرق وسطیٰ کی معروف کمپنیوں کے لیے قابل اعتماد، منظم اور پیشہ ورانہ مین پاور بھرتی حل فراہم کرتے ہیں۔",
      primaryCta: "ماہر ورکرز حاصل کریں",
      secondaryCta: "رابطہ کریں"
    },
    compact: {
      stats: ["سال کا تجربہ", "امیدوار بھرتی ہوئے", "مطمئن کلائنٹس", "ممالک"],
      whyTitle: ["کیوں منتخب کریں", "پاک عربین", "مین پاور سروسز؟"],
      whyCards: [
        ["لائسنس یافتہ اور حکومتی رجسٹرڈ", "وزارت داخلہ اور وزارت خارجہ، حکومت پاکستان سے منظور شدہ۔"],
        ["25+ سال کی بہترین خدمات", "بین الاقوامی بھرتی خدمات کا دو دہائیوں سے زائد تجربہ۔"],
        ["ماہر ورکرز کا وسیع پول", "پری اسکرینڈ اور ماہر امیدواروں کے بڑے ڈیٹا بیس تک رسائی۔"],
        ["تیز اور قابل اعتماد ویزا پروسیسنگ", "تیز تعیناتی کے لیے موثر دستاویزات اور ویزا پروسیسنگ۔"],
        ["معروف کمپنیوں کا اعتماد", "سعودی عرب اور مشرق وسطیٰ کی تنظیموں کی خدمت۔"],
        ["مخصوص سپورٹ ٹیم", "ہماری ٹیم بہترین مدد کے لیے ہمیشہ تیار ہے۔"]
      ],
      aboutKicker: "پاک عربین کے بارے میں",
      aboutTitle: ["پیشہ ور مین پاور پارٹنر", "سعودی عرب اور مشرق وسطیٰ کے لیے"],
      aboutText: "ہم بین الاقوامی آجروں کو بھرتی کوآرڈینیشن، امیدواروں کی اسکریننگ، دستاویزات اور تعیناتی کی تیاری میں مدد دیتے ہیں۔",
      aboutPoints: ["لائسنس یافتہ مین پاور سپورٹ", "آجر پر مرکوز کوآرڈینیشن", "قابل اعتماد بیرون ملک تعیناتی"],
      downloadProfile: "کمپنی پروفائل ڈاؤن لوڈ کریں",
      viewProfile: "کمپنی پروفائل دیکھیں",
      trustedTitle: ["اعتماد", "معروف کمپنیوں کا"],
      trustedText: "متعدد صنعتوں کی کمپنیوں کی جانب سے تسلیم شدہ۔",
      industriesTitle: ["صنعتیں", "جنہیں ہم خدمات دیتے ہیں"],
      processTitle: ["ہمارا بھرتی", "عمل"],
      industries: [
        ["تعمیرات", "سائٹ اور سول ورکس کے لیے مین پاور۔"],
        ["انجینئرنگ", "خصوصی کرداروں کے لیے تکنیکی ورکرز۔"],
        ["آئل اینڈ گیس", "توانائی کے شعبوں کے لیے صنعتی سپورٹ۔"],
        ["ہیلتھ کیئر", "صحت اور سپورٹ اسٹاف۔"],
        ["مینوفیکچرنگ", "فیکٹری، پلانٹ اور پروڈکشن ٹیمیں۔"],
        ["ہاسپیٹلیٹی", "ہوٹل، سروس اور سہولیات کا اسٹاف۔"],
        ["سیرامک انڈسٹری", "فیکٹری اور پروڈکشن مین پاور۔"],
        ["ٹرانسپورٹ", "ڈرائیورز، لاجسٹکس اور ٹرانسپورٹ سپورٹ۔"],
        ["فیسلٹی مینجمنٹ", "مینٹیننس اور سہولیات کی ورک فورس۔"],
        ["اور بہت کچھ", "مختلف آجر ضروریات کے لیے لچکدار مین پاور سپورٹ۔"]
      ],
      process: ["ضرورت موصول", "امیدوار اسکریننگ", "انٹرویوز اور ٹریڈ ٹیسٹ", "طبی معائنہ", "ویزا پروسیسنگ", "روانگی اور تعیناتی"]
    },
    appreciations: {
      kicker: "پذیرائی",
      title: "آجروں کا اعتماد، خدمت کی پہچان۔",
      description: "",
      trustOne: "قابل اعتماد رابطہ",
      trustTwo: "دستاویزی پذیرائی",
      trustThree: "آجر پر مرکوز سپورٹ",
      recognitionFrom: "پذیرائی از",
      recognitionText: "جو پاک عربین کی قابل اعتماد بھرتی اور مین پاور سپورٹ کو ظاہر کرتی ہے۔",
      issuer: "جاری کرنے والا",
      recognitionType: "پذیرائی کی قسم",
      letter: "خط",
      certificate: "سرٹیفکیٹ",
      letterTitle: "تعریفی خط",
      certificateTitle: "تعریفی سرٹیفکیٹ",
      viewDocument: "مکمل دستاویز دیکھیں",
      hint: "شوکیس میں دیکھنے کے لیے کوئی پذیرائی منتخب کریں۔",
      show: "دکھائیں",
      from: "از"
    },
    contact: {
      kicker: "رابطہ کریں",
      title: "کیا آپ مین پاور ضروریات پر بات کرنا چاہتے ہیں؟",
      description: "اپنی بھرتی کی ضروریات، امیدواروں سے متعلق سوالات، یا کمپنی پروفائل کی درخواست شیئر کریں۔ پاک عربین وضاحت کے ساتھ مدد کے لیے تیار ہے۔",
      whatsapp: "واٹس ایپ پر پیغام بھیجیں",
      callNow: "ابھی کال کریں",
      ourOffice: "ہمارا دفتر",
      getInTouch: "رابطے میں رہیں",
      directionsText: "ہمارے دفتر کی سمت حاصل کریں",
      phone: "فون",
      office: "دفتر",
      address: ["پاک عربین مین پاور سروسز", "دوسری منزل، مڈوے کمرشل", "عطار پلازہ، بحریہ ٹاؤن فیز VII", "اسلام آباد، پاکستان"],
      maps: "Google Maps میں کھولیں",
      hours: "اوقات کار",
      days: "پیر سے ہفتہ",
      time: "صبح 9:00 تا شام 5:00",
      email: "ای میل"
    },
    lower: {
      title: "ماہر ورکرز بھرتی کرنا چاہتے ہیں؟",
      text: "ہم آپ کے کاروبار کے لیے بہترین مین پاور حل فراہم کرتے ہیں۔",
      emailRequirements: "ضروریات ای میل کریں",
      call: "ابھی کال کریں",
      whatsapp: "واٹس ایپ پر چیٹ",
      copyright: "پاک عربین مین پاور سروسز۔",
      designed: "ڈیزائن از پاک عربین ٹیم"
    }
  }
};
